import { render, staticRenderFns } from "./RecentInvoices.vue?vue&type=template&id=c77d393c&"
import script from "./RecentInvoices.vue?vue&type=script&lang=js&"
export * from "./RecentInvoices.vue?vue&type=script&lang=js&"
import style0 from "./RecentInvoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports